var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 6,
    viewBox: "0 0 11 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.857469 0.147684C0.661311 -0.0492278 0.343276 -0.0492279 0.147118 0.147683C-0.0490397 0.344595 -0.0490393 0.663851 0.147119 0.860763L5.11957 5.85232C5.22407 5.95721 5.36315 6.00623 5.49997 5.99937C5.6368 6.00623 5.77588 5.95721 5.88038 5.85232L10.8528 0.860763C11.049 0.663851 11.049 0.344595 10.8528 0.147683C10.6567 -0.0492279 10.3386 -0.0492278 10.1425 0.147684L5.49997 4.80802L0.857469 0.147684Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ca581e723472bacffb549a8536fb7aff.svg";
export { ForwardRef as ReactComponent };